export const paginator = {
  components: {
    Paginator: () => import('@/components/Paginator.vue')
  },
  data: () => ({
    totalCount: 0,
    currentPage: 1,
    perPage: 10
  }),
  watch: {
    currentPage() {
      if (this.loadData) {
        this.loadData()
      }
    },
    perPage() {
      this.currentPage = 1
      if (this.loadData) {
        this.loadData()
      }
    }
  },
  computed: {
    pageParams() {
      return {
        $limit: this.perPage,
        $skip: this.skipCount
      }
    },
    skipCount() {
      return (this.currentPage - 1) * this.perPage
    },
    showPaginator() {
      return this.totalCount > 10
    }
  }
}
